// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './Login';
import NewPassword from './NewPassword';
import Dashboard from './Dashboard';

function App() {
  return (
    <Router>
      <Routes>
        {/* Etusivu: Login */}
        <Route path="/" element={<Login />} />
        
        {/* Uuden salasanan asettaminen */}
        <Route path="/new-password" element={<NewPassword />} />
        
        {/* Dashboard-näkymä */}
        <Route path="/dashboard" element={<Dashboard />} />
        
        {/* Kaikki muut polut? esim 404 */}
      </Routes>
    </Router>
  );
}

export default App;
